import MicroModal from 'micromodal';

MicroModal.init({
  disableScroll: true,
});

const modalOpen = (event) => {
  MicroModal.show('modal-1');
  const content = document.querySelectorAll(
    '[aria-describedby="modal-1-content"] img'
  );
  if (content.length) {
    const imgSrc = event.target.getAttribute('data-src');
    content[0].src = imgSrc;
  }
};
const modalClose = () => {
  MicroModal.close('modal-1');
};

const triggerOpen = document.querySelectorAll('[data-micromodal-open]');
const triggerClose = document.querySelectorAll('[data-micromodal-close]');

triggerOpen.forEach((item) => {
  item.addEventListener('click', modalOpen, false);
});

triggerClose.forEach((item) => {
  item.addEventListener('click', modalClose, false);
});
